module.exports = "<router-outlet><app-spinner><app-title></app-title></app-spinner></router-outlet>\n<ng2-toasty [position]=\"'top-right'\"></ng2-toasty>\n"